export default "__VITE_ASSET__1217d43a__"